import {EventEmitter} from "../components/EventEmitter";
import {EventModel} from "../models/EventModel";
import {translator} from "../services/TranslatorService";

export class EventInterface {
	constructor() {
		/* компоненты */
		this.emitter = new EventEmitter();
		this.interactPlan = null;
		this.eventOrder = null;

		/* модель и представление */
		this.model = new EventModel();
		this.view = null;
	}

	initEventEmitter() {
		translator.getLanguages().then(() => {
			this.setUpSubscribers();
			this.setUpListeners();
		});
	}

	/* Инициализция подписчиков */
	setUpSubscribers() {}

	/* Инициализция обработчиков */
	setUpListeners() {}
}
